import * as React from 'react';
import styled, { css, useTheme } from 'styled-components';
const Wrapper = styled('span') `
  ${({ $color }) => $color &&
    css `
      color: ${$color};
    `};
`;
export function getColorFromProps(theme, props) {
    if (props.danger) {
        return theme.color.danger;
    }
    else if (props.success) {
        return theme.color.success;
    }
    else if (props.warning) {
        return theme.color.warning;
    }
    else if (props.faded) {
        return theme.color.fadedText;
    }
    else if (props.primary) {
        return theme.color.primary;
    }
    return 'inherit';
}
const Text = ({ className, children, primary = false, danger = false, success = false, warning = false, faded = false, color, }) => {
    const theme = useTheme();
    let textColor = '';
    if (color) {
        textColor = color;
    }
    else {
        textColor = getColorFromProps(theme, {
            primary,
            danger,
            success,
            warning,
            faded,
        });
    }
    return (React.createElement(Wrapper, { className: className, "$color": textColor }, children));
};
export default Text;
